import styled from 'styled-components';

export const StyledDiv = styled('div')`
  background: linear-gradient(
    180deg,
    rgba(27, 34, 45, 1) 0%,
    rgba(31, 38, 50, 1) 100%
  );
  border-radius: ${({ theme }) => `${theme.x1}px`};
`;

export const StyledText = styled('div')`
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: helper;
`;
